window.clearUrlParams = () => {
    const url = new URL(window.location);
    url.search = '';

    window.history.replaceState({}, null, url);
}
